import {
  Component,
  Optional,
  Inject,
  Input,
  ViewChild,
  Injector,
} from '@angular/core';

import {
  NgModel,
  NG_VALUE_ACCESSOR,
  NG_VALIDATORS,
  NG_ASYNC_VALIDATORS,
} from '@angular/forms';

import {ElementBase, animations} from '../form';

@Component({
  selector: 'form-hidden',
  template: `
      <input
        type="hidden"
        [(ngModel)]="value"
        [id]="identifier"
      />
  `,
  animations: [],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: FormHiddenComponent,
    multi: true,
  }]
})
export class FormHiddenComponent extends ElementBase<string> {
  @ViewChild(NgModel) model: NgModel;

  public identifier = `form-hidden-${identifier++}`;

  constructor(
    @Optional() @Inject(NG_VALIDATORS) validators: Array<any>,
    @Optional() @Inject(NG_ASYNC_VALIDATORS) asyncValidators: Array<any>,
    injector: Injector
  ) {
    super(validators, asyncValidators, injector);
  }
}

let identifier = 0;


// WEBPACK FOOTER //
// ./src/app/base/base-fields/components/hidden.ts